exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.language-toggler .dropdown-menu {\n\t/* margin: 20px; */\n\tpadding: 0;\n}\n", ""]);

// exports
